<template>
  <div class="flex flex-col gap-4">
    <TextTitle>Gegevens</TextTitle>
    <AssetInfoPanel :metering-point="filterStore.currentMeteringPoint" />
  </div>

  <!-- SDE -->
  <div v-if="hasSDE" class="flex flex-col gap-4">
    <BaseDivider class="py-2" />
    <TextTitle>SDE++ gegevens</TextTitle>
    <AssetSdePanel :metering-point="filterStore.currentMeteringPoint" />
  </div>

  <!-- Active markets -->
  <div v-if="isAsset" class="flex flex-col gap-4">
    <BaseDivider class="py-2" />
    <TextTitle>Actieve markten</TextTitle>
    <ActiveMarketsPanel :metering-point="filterStore.currentMeteringPoint" />
  </div>
</template>

<script setup>
import { computed } from "vue"
import useFilterStore from "@/stores/filterStore.js"
import { ASSET } from "@/stores/repower/meteringPointStoreFactories.js"
import { TextTitle, BaseDivider } from "@repowerednl/ui-component-library"
import AssetInfoPanel from "@/components/panels/AssetInfoPanel.vue"
import AssetSdePanel from "@/components/panels/AssetSdePanel.vue"
import ActiveMarketsPanel from "@/components/panels/ActiveMarketsPanel.vue"

const filterStore = useFilterStore()

const isAsset = computed(() => filterStore.currentMeteringPoint?.role === ASSET)

const hasSDE = computed(
  () => !!filterStore.currentMeteringPoint?.properties?.sde_decision?.year,
)
</script>
